import {MonitoringState} from "../entity/state/MonitoringState";
import {ProcessStatus} from "../entity/ProcessStatus";

export const initialMonitoringState: MonitoringState = {
    productPropertyCategoryData: {},
    productPropertyCategoryStatus: {},
    productMonthData: [],
    productMonthStatus: ProcessStatus.None,
};